<template>
  <div class="flex items-center">
    <button v-if="visit_count > 0" @click="openModal()" class="text-blue-primary hover:underline">{{ visit_count }}</button>
    <p v-else>-</p>

    <jet-dialog-modal :show="modalOpen" @close="closeModal" ref="modal">
      <template #title>
        Link visits by {{ data.recipient_name }}
      </template>

      <template #content>
        <div v-for="(links, key) in data.link_visits" class="mb-4">
          <div v-if="links.length">
            <p>txts.pt/l/{{ key }}</p>
            <ul class="list-disc pl-4 mt-2">
              <li v-for="visit in links">{{ visit }}</li>
            </ul>
          </div>
        </div>
      </template>

      <template #footer>
        <button class="mr-4" @click="closeModal">
          Close
        </button>
      </template>
    </jet-dialog-modal>

  </div>
</template>

<script>

import JetDialogModal from "../Jetstream/DialogModal.vue";
import JetSecondaryButton from "../Jetstream/SecondaryButton.vue";

export default {
  name: "MessageTableLinkVisits",
  emits: ['close'],
  components: {JetSecondaryButton, JetDialogModal},
  props: {
    data: {
      type: Object,
      default: () => {}
    },
  },
  data: () => ({
    modalOpen: false
  }),
  computed: {
    visit_count: function () {
      let count = 0;
      if ( !this.data.link_visits ) { return count; }

      // link visits are sent as an object of arrays where each array
      // holds the timestamp of a link visits
      for (const [key, value] of Object.entries(this.data.link_visits)) {
        count += value.length;
      }

      return count;
    }
  },
  mounted() {
  },
  methods: {
    openModal: function () {
      this.modalOpen = true;
    },
    closeModal: function () {
      this.modalOpen = false;
      this.$emit('close')
    },
  },
};
</script>

<style scoped lang="scss">

</style>
